module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-popover', {
    attrs: {
      "content": _vm.missionPopoverContent,
      "triggers": ['hover']
    }
  }, [_c('div', {
    staticClass: "card card-inverse calendar-mission",
    class: {
      'card-primary': !_vm.mission.isAssignedToAnySlot && !_vm.mission.isRegisteredForAnySlot, 'card-info': !_vm.mission.isAssignedToAnySlot && _vm.mission.isRegisteredForAnySlot, 'card-success': _vm.mission.isAssignedToAnySlot
    },
    on: {
      "click": _vm.redirectToMissionDetails
    }
  }, [_c('div', {
    staticClass: "card-header calendar-mission-title"
  }, [_vm._v(_vm._s(_vm.mission.title))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b17cba1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/calendar/CalendarMission.vue
// module id = 505
// module chunks = 0